import { mapState } from 'vuex';

export default {
    name: 'wai_authorizationwz',
    props: {
    },

    data : function(){

        return {
            loading : false
        }

    },

    mounted() {

    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        ios : function(){
            return window.cordova && window.device && this.$f.deep(window, 'device.platform') == 'iOS'
        },
        phoneEnabled : function(){
            return process.env.VUE_APP_PHONE_ENABLED == 1;
        },
    }),

    methods : {
        applesignin : function(){

        },
        applesignin : function(){
            var t = this

            t.loading = true

            this.$root.authways.signin.apple().then(r => {

                t.loading = false

                t.$store.commit('lastlogin', '')

                var pr = _.filter(this.$root.user.userProblems(), function(c){
                    return c.critical
                })

                if(pr.length){
                    t.$router.push('/profilewizard/')
                }
                else{
                    t.$router.push('/')
                }


            }).catch( e => {

                t.loading = false
                console.error("ERROR", e)

                t.$message({
                    title : "Failed",
                    message : "Sign in with Apple failed"
                })

            })
        },
        googlesignin : function(){
            var t = this

            t.loading = true

            this.$root.authways.signin.google().then(r => {

                t.loading = false

                t.$store.commit('lastlogin', '')

                var pr = _.filter(this.$root.user.userProblems(), function(c){
                    return c.critical
                })

                if(pr.length){
                    t.$router.push('/profilewizard/')
                }
                else{
                    t.$router.push('/')
                }


            }).catch( e => {

                t.loading = false
                console.error("ERROR", e)

                t.$message({
                    title : "Failed",
                    message : "Sign in with Google failed"
                })

            })
        }
    },
}